import { type RefObject, useEffect, useRef, useState } from 'react';

export const useCountRows = (): [
  numberOfRows: number,
  targetRef: RefObject<HTMLDivElement | null>,
] => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [numberOfRows, setNumberOfRows] = useState<number>(0);

  useEffect(() => {
    const countRows = () => {
      if (!targetRef.current) return;

      const firstElement = targetRef.current.children[0] as HTMLElement;

      if (!firstElement) return;

      const elementHeight = firstElement.offsetHeight;
      const containerHeight = targetRef.current.getBoundingClientRect().height;

      if (elementHeight > 0) {
        setNumberOfRows(Math.floor(containerHeight / elementHeight));
      }
    };

    countRows();
  }, []);

  return [numberOfRows, targetRef];
};
